/* eslint-disable */
export const user = {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name  : 'Demo',
    email : 'user@user.com.tr',
    avatar: 'assets/images/user.png',
    status: 'online'
};
